import { useCallback, useContext } from 'react';

import { Notification } from '@savgroup-front-common/types';

import ToastsContext from '../ToastsProvider.context';

export type UsePushNotificationReturnType = (toast: Notification) => void;

const usePushNotification = () => {
  const { pushNotifications } = useContext(ToastsContext);

  return useCallback(
    (toast: Notification) => {
      pushNotifications([toast]);
    },
    [pushNotifications],
  );
};

export default usePushNotification;
